export { default as AgentsPage } from './Agents/agents';
export { default as AgentProfilePage } from './AgentProfile/agent-profile';
export { default as AgentMigrationsPage } from './AgentMigrations/agent-migrations';
export { default as ReferralDepthFixPage } from './ReferralDepthFix/referral-depth-fix';
export { default as CountriesPage } from './Countries/countries';
export { default as AgentDealUpdateRequestsPage } from './AgentDealUpdateRequests/agent-deal-update-requests';
export { default as RegionsPage } from './Regions/regions';
